import { Form, Button, Container, Header } from "semantic-ui-react";
import { toast } from "react-toastify";
import React, { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import {
  user_Authenticated,
  user_Not_Authenticated,
} from "../../features/auth/authSlice";

const Login = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };
  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };
  const onSubmitForm = async (e) => {
    e.preventDefault();
    try {
      const body = { email, password };
      const response = await fetch(
        `${process.env.REACT_APP_SERVER}authentication/login`,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      const parseRes = await response.json();

      if (parseRes.jwtToken) {
        sessionStorage.setItem("token", parseRes.jwtToken);
        dispatch(user_Authenticated(parseRes));
        toast.success("Logged in Successfully");
      } else {
        dispatch(user_Not_Authenticated());
        toast.error(parseRes);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  return (
    <Fragment>
      <Container className="LoginForm" text>
        <Header textAlign="center" as="h1">
          Login
        </Header>
        <Form onSubmit={onSubmitForm}>
          <Form.Field>
            <label>Email</label>
            <input
              placeholder="Email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => onChangeEmail(e)}
            />
          </Form.Field>
          <Form.Field>
            <label>Mot de passe</label>
            <input
              placeholder="Password"
              type="password"
              name="password"
              value={password}
              onChange={(e) => onChangePassword(e)}
            />
          </Form.Field>
          <Button type="submit">Login</Button>
        </Form>
      </Container>
    </Fragment>
  );
};

export default Login;
